import axios from '../../axios';
import { useQuery } from '@tanstack/react-query';
import type { TLessonCategoryBase, TError } from '@onesource/schemas';
import { ENTITY } from '../entity';

/**
 * Query key for fetching categories for a parent lesson - non-hook version
 */
export const getCategoriesQueryKey = (parentLessonId: string) => [ENTITY, 'lessons', parentLessonId, 'categories'];

/**
 * Query key for fetching categories for a parent lesson
 */
export const useGetCategoriesQueryKey = (parentLessonId: string) => getCategoriesQueryKey(parentLessonId);

/**
 * Hook to fetch categories for a parent lesson
 * Categories are used to group sub-lessons within a parent lesson
 *
 * @param parentLessonId - Parent Lesson ID (UUID)
 */
export const useGetCategories = (parentLessonId: string) => {
  return useQuery<TLessonCategoryBase[], TError>({
    queryKey: useGetCategoriesQueryKey(parentLessonId),
    queryFn: async () => {
      const res = await axios.get<TLessonCategoryBase[]>(`/community-hub/lessons/${parentLessonId}/categories`);
      return res.data;
    },
    enabled: !!parentLessonId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
